import { useTranslate } from '@tolgee/react'
import { TomTable, useTomTable } from '@tom-ui/ui'
import { useTablePreferencesConfig } from '@tom-ui/utils'
import { observer } from 'mobx-react-lite'
import { useMemo } from 'react'
import {
  ContainerTurnoverListTableColumnsDto,
  ContainerTurnoverListViewStore,
} from '../../stores/container-turnover-list.view-store'
import { getContainerTurnoverListColumns } from '../../tableConfigs/containerTurnoverListColumns'
import { ContainerTurnoverListMenuOptions } from '../molecules/ContainerTurnoverListMenuOptions'

interface Props {
  listStore: ContainerTurnoverListViewStore
}
export const ContainerTurnoversTable = observer(({ listStore }: Props) => {
  const { t } = useTranslate()

  const columns = useMemo(() => getContainerTurnoverListColumns(t), [t])

  const { savedPreferences, onPreferencesChange } = useTablePreferencesConfig(
    'host/container-turnovers',
  )

  const table = useTomTable<ContainerTurnoverListTableColumnsDto>(
    {
      columns,
      data: listStore.ordersTableData,
      enableTopToolbar: false,
      enableRowSelection: false,
      enableExpanding: false,
      getRowId: row => row.id.toString(),
      renderRowActions: ({ row }) => (
        <ContainerTurnoverListMenuOptions containerTurnover={row.original} listStore={listStore} />
      ),
      muiTableBodyRowProps: ({ row }) => ({
        id: `turnover-list-row-${row.original.number}`,
      }),
    },
    undefined,
    undefined,
    { columns, savedPreferences, onPreferencesChange },
  )

  return <TomTable table={table} />
})
